import { Fetch, schemas } from '@convergence/client';
import { useQuery } from '@tanstack/react-query';
import { fetch } from '../fetch';

export async function getNotebooks(fetch: Fetch) {
  return fetch('/notebook', { method: 'get' }, schemas.GetNotebooksDto);
}

export const useNotebooksQuery = () => {
  return useQuery({
    queryKey: ['notebooks'],
    retry: false,
    queryFn: async () => {
      try {
        const notebooks = await getNotebooks(fetch);
        return notebooks;
      } catch (err) {
        console.error(err);
      }
    }
  });
};
